// extracted by mini-css-extract-plugin
export var label = "_ca-1";
export var reminder = "_ca-0";